module.exports = __webpack_public_path__ + "img/national-cancer-inst.9a3da7ab.png";